<app-welcome-message></app-welcome-message>
<ul class="nav__list primary-nav__group-list">
	<li *ngFor="let group of navGroups" class="nav__item primary-nav__group">
		<app-nav-group [navGroup]="group"></app-nav-group>
	</li>
</ul>